import type { FaireProductEntity } from "../../entity_types/product";

export const p_eggvmc4a6x: FaireProductEntity = {
  token: "p_eggvmc4a6x",
  type: "product",
  name: "Unwind Mineral Bath Soak",
  brandToken: "b_khkkpxpgu3",
  brandName: "6pm Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/f95371baaaeba73b6d145974d837f1c7d4f8c6d8839609ecab9378f74c204e4f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e31ab8d9ec74c17c26daf281819966f84c497d40d8ca278b1fa997a522c8c6f.jpeg",
    "https://cdn.faire.com/fastly/0d4d933b87a08149a3b6df7c9fa5e100847ebc033e9ddddc369c71cfd813ceec.jpeg",
  ],
  priceDollars: 9,
  description:
    "Our bath soaks are hand blended and carefully curated with pure therapeutic essential oils and salts that help banish dry skin, improve the texture and tone of your skin, and ease muscle soreness.\n\nUnwind Bath Soak relaxes the mind, promoting a peaceful sleep with a relaxing aroma while containing anti-inflammatory and antibacterial properties that nurture smooth, healthy skin and relieves irritations.\n\nIngredients: Exotic dead sea salt, Himalayan pink salt, epsom salt, organic therapeutic essential oils (lavender, Roman Chamomile, Vetiver, Frankincense)\n\n•Certified Organic\n\n• Weight: 8 oz\n• Package: Made from certified home compostable materials\n• Handmade small batch in Houston, Tx\n\nThis products is not intended to diagnose, treat, cure or prevent any disease.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:15.446Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
